module.exports = __webpack_public_path__ + "img/all_head copy.fb228bd8.jpg";